import { render, staticRenderFns } from "./CI.vue?vue&type=template&id=47e28738&scoped=true"
import script from "./CI.vue?vue&type=script&lang=js"
export * from "./CI.vue?vue&type=script&lang=js"
import style0 from "./CI.vue?vue&type=style&index=0&id=47e28738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e28738",
  null
  
)

export default component.exports